<form class="form-container" [formGroup]="signInForm" (ngSubmit)="onSubmit()">
  <div class="inner-form-container">
    <app-custom-input
      [formControlName]="'userName'"
      [type]="'text'"
      [id]="'username'"
      [label]="LABEL_CONSTANT.USERNAME_EMAIL"
      [icon]="'user-input-icon.svg'"
      [placeholder]="PLACEHOLDER_CONSTANT.EMAIL_FORMAT"
      [required]="true"
    />
    <app-custom-input
      [formControlName]="'password'"
      [type]="'password'"
      [id]="'password'"
      [label]="LABEL_CONSTANT.PASSWORD"
      [icon]="'lock.svg'"
      [showHide]="true"
      [required]="true"
    />
    <app-custom-input
      [formControlName]="'rememberUsername'"
      [type]="'checkbox'"
      [id]="'rememberUsername'"
      [label]="LABEL_CONSTANT.REMEMBER_USERNAME_TEXT"
    />

  </div>
  <app-button
    [type]="'submit'"
    [className]="'primary-form-button'"
    [label]="LABEL_CONSTANT.LOGIN"
    [isLoader]="isSignInLoading"
  />
  <div class="nav-link">
    <a 
      role="button" 
      tabindex="0" 
      (click)="switchToForgotPasswordFlow()" 
      (keydown.enter)="switchToForgotPasswordFlow()" 
      (keydown.space)="switchToForgotPasswordFlow()"
    >
      {{LABEL_CONSTANT.FORGOT_PASSWORD}}
    </a>
  </div>
</form>
